/**
 * Parse the JSON body attached to a Supabase FunctionsHttpError.
 *
 * `supabase.functions.invoke()` throws a FunctionsHttpError for any non-2xx
 * response and does NOT put the body in `data` — it is only reachable via the
 * raw Response stored on `error.context`. Returns null if the error didn't
 * expose a Response, the body isn't JSON, or the JSON is malformed — callers
 * should treat null as "not the structured error I'm looking for, rethrow".
 */
export async function parseInvokeErrorBody(
  err: unknown,
): Promise<Record<string, unknown> | null> {
  if (!err || typeof err !== 'object') return null;
  const ctx = (err as { context?: unknown }).context;
  if (!ctx || typeof ctx !== 'object') return null;
  const response = ctx as { json?: () => Promise<unknown> };
  if (typeof response.json !== 'function') return null;
  try {
    const body = await response.json();
    if (body && typeof body === 'object') {
      return body as Record<string, unknown>;
    }
    return null;
  } catch {
    return null;
  }
}
